import { useLanguage } from '../lib/i18n';

export function LanguageSelect() {
  const { language, setLanguage } = useLanguage();
  const label = language === 'en' ? 'Language' : 'Dil';

  return (
    <label className="language-select">
      <span>{label}</span>
      <select className="select" value={language} onChange={(event) => setLanguage(event.target.value as 'tr' | 'en')}>
        <option value="tr">Türkçe</option>
        <option value="en">English</option>
      </select>
    </label>
  );
}
